import React from 'react'

import { useSliceTemplate } from 'src/context/global'
import { NavbarDefault } from './NavbarDefault'
import { NavbarSlice } from './NavbarSlice'

interface NavbarProps {
  onRequestContact(): void
}

export const Navbar: React.FC<NavbarProps> = ({ onRequestContact }) => {
  const isSliceTemplate = useSliceTemplate()

  return isSliceTemplate ? (
    <NavbarSlice onRequestContact={onRequestContact} />
  ) : (
    <NavbarDefault onRequestContact={onRequestContact} />
  )
}
